// src/features/logs/accessLogsSaga.js
import SuperFetch from 'library/helpers/superFetch';
import { expandArrayParams, removeEmptyOrNull } from 'library/helpers/utility';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { lockersLogsActions } from './slice';

export function* loadLockersLogs(action) {
	const { fromDate, toDate, personIDs = [], deviceIDs = [] } = action?.payload || {};

	try {
		// Get the orgID from the selected profile
		const { orgID } = yield select((state) => state.Auth.selectedProfile);

		// Calculate offset based on page
		const logs = yield call(() =>
			SuperFetch.get(
				'/logs',
				{},
				expandArrayParams({
					...removeEmptyOrNull({
						orgID,
						personIDs,
						deviceIDs,
						fromDate: fromDate ? new Date(fromDate).toISOString() : undefined,
						toDate: toDate ? new Date(toDate).toISOString() : undefined
					})
				})
			)
		);

		if (logs.statusCode === 200) {
			yield put(
				lockersLogsActions.loadLockersLogsSuccess({
					orgID,
					data: logs.data,
					total: logs.info?.total || 0
				})
			);
		} else {
			throw new Error(logs.message || 'Failed to load access logs.');
		}
	} catch (error) {
		yield put(lockersLogsActions.loadLockersLogsError(error));
	}
}

export default function* accessLogsSaga() {
	yield takeLatest(lockersLogsActions.loadLockersLogs, loadLockersLogs);
}
